import { Component, OnInit } from '@angular/core';
import { MedicosService } from 'src/app/services/medicos.services';

@Component({
  selector: 'app-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.scss']
})
export class DoctorComponent implements OnInit {

  constructor(public medicos: MedicosService) { }

  ngOnInit(): void {
  }

}
